// ============================================================================
// FILE: src/modules/invoice/routes/InvoiceRoutes.jsx
// CREATED: 2025-12-03
// PURPOSE: Internal routing for Invoice Management Module.
//
// Routes:
//   /invoices               -> InvoiceListPage
//   /invoices/upload        -> InvoiceUploadPage
//   /invoices/:id           -> InvoiceDetailPage
//
// Loaded from App.js using:
//   <Route path="/invoices/*" element={<InvoiceRoutes />} />
// ============================================================================

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Pages
import InvoiceListPage from "../pages/InvoiceListPage";
import InvoiceUploadPage from "../pages/InvoiceUploadPage";
import InvoiceDetailPage from "../pages/InvoiceDetailPage";

const InvoiceRoutes = () => {
  return (
    <Routes>

      {/* List Page */}
      <Route path="/" element={<InvoiceListPage />} />

      {/* Upload Page */}
      <Route path="/upload" element={<InvoiceUploadPage />} />

      {/* Detail Page */}
      <Route path="/:id" element={<InvoiceDetailPage />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/invoices" replace />} />

    </Routes>
  );
};

export default InvoiceRoutes;
